<template>
  <!-- 忘记密码 -->
  <el-dialog ref="dialog" :visible.sync="$store.state.changepassshow" :lock-scroll="false" width="30%" center
    :show-close="false">
    <div class="register">
      <div>忘记密码</div>
      <div @click="$store.commit('setChangepassshow', false)">×</div>
    </div>
    <!-- <div style="color: #a9aeb8; line-height: 2; margin-bottom: 8px">
      国家知识产权国际运营平台
    </div> -->
    <el-form :model="changeMobile" ref="changeMobile" class="demo-dynamic">
      <!-- 手机号 -->
      <div>
        <div class="email">手机号/邮箱</div>
        <el-form-item prop="mobile" :rules="rules.mobile">
          <el-input type="tel" maxlength="11" placeholder="请输入手机号/邮箱" v-model="changeMobile.mobile"></el-input>
        </el-form-item>
      </div>
      <!-- 验证码 -->
      <div>
        <div class="email">验证码</div>
        <div>
          <el-form-item prop="mobilein" :rules="rules.mobilein">
            <el-input placeholder="输入4位验证码" maxlength="4" v-model="changeMobile.mobilein">
              <template slot="append">
                <span style="margin-right: 14px; color: #c9cdd4">|</span>
                <el-button @click="sendOutCode()" type="primary" :disabled="judge || !changeMobile.mobile">{{ countdown
                }}</el-button>
              </template>
            </el-input>
          </el-form-item>
        </div>
      </div>
      <!-- 图形验证码 -->
      <div>
        <div class="email">图形验证码</div>
        <el-form-item prop="captcha">
          <div style="display: flex;">
            <el-input type="tel" maxlength="11" placeholder="请输入验证码" v-model="changeMobile.captcha">
            </el-input>
            <img :src="baseUrl + '/security/captcha'" alt="captcha" style="margin-left: 8px;cursor: pointer;"
              @click="getCaptcha()" ref="captcha">
          </div>
        </el-form-item>
      </div>

      <!-- 新密码 -->
      <div>
        <div class="email">新密码</div>
        <el-form-item prop="mobilepass" :rules="rules.mobilepass">
          <el-input type="tel" placeholder="请输入新密码" v-model="changeMobile.mobilepass"></el-input>
        </el-form-item>
      </div>

      <!-- 再次输入密码 -->
      <div>
        <div class="email">再次输入密码</div>
        <el-form-item prop="mobilepasscf" :rules="rules.mobilepasscf">
          <el-input type="tel" placeholder="请再次输入密码" v-model="changeMobile.mobilepasscf"></el-input>
        </el-form-item>
      </div>
    </el-form>

    <el-button style="width: 100%; margin-top: 20px" type="primary" @click="submitForm('changeMobile')"
      :disabled="disBtn">
      修改</el-button>
  </el-dialog>
</template>

<script>
import { postRequest } from "../api/api";
import { passwordVerification } from "../api/util";
import { baseUrl } from "../api/constant";
let timer;
export default {
  data() {
    const validatePhone = (rule, value, callback) => {
      if (value.length === 0) {
        callback(new Error("请输入手机号或邮箱"));
      } else {
        callback();
      }
    };
    const validateMobilein = (rule, value, callback) => {
      if (value.length === 0) {
        callback(new Error("请输入验证码"));
      } else if (value.length !== 4) {
        callback(new Error("验证码错误"));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (value.length === 0) {
        callback(new Error("请输入密码"));
      } else if (value.length < 8) {
        callback(new Error("请输入至少8位数密码"));
      } else if (!passwordVerification(value)) {
        callback(new Error("请输入至少大小字母数字符合包含2种"));
      } else {
        callback();
      }
    };
    const validatePasswordcf = (rule, value, callback) => {
      if (value.length === 0) {
        callback(new Error("请输入密码"));
      } else if (value !== this.changeMobile.mobilepass) {
        callback(new Error("两次输入的密码不同"));
      } else {
        callback();
      }
    };
    return {
      baseUrl,
      changeMobile: {
        mobile: "",
        mobilein: "",
        mobilepass: "",
        mobilepasscf: "",
        captcha: ""
      },
      rules: {
        mobile: [
          {
            required: true,
            validator: validatePhone,
            trigger: "blur",
          },
        ],
        mobilein: [
          {
            required: true,
            validator: validateMobilein,
            trigger: "blur",
          },
        ],
        mobilepass: [
          {
            required: true,
            validator: validatePassword,
            trigger: "blur",
          },
        ],
        mobilepasscf: [
          {
            required: true,
            validator: validatePasswordcf,
            trigger: "blur",
          },
        ],
      },
      judge: false, //禁用按钮
      countdown: "发送验证码", //验证码倒计时
    };
  },
  computed: {
    disBtn() {
      if (
        this.changeMobile.mobile &&
        this.changeMobile.mobilein &&
        this.changeMobile.mobilepass &&
        this.changeMobile.mobilepasscf
      ) {
        return false;
      } else {
        return true;
      }
    },
  },
  methods: {
    // 更新图形验证码
    getCaptcha() {
      this.$refs.captcha.src = baseUrl + '/security/captcha'
    },
    // 发送验证码{
    sendOutCode() {
      if (this.countdown.indexOf("倒计时") >= 0) return;
      this.sendOut();
      let time = 59;
      this.countdown = `倒计时（${time}）`;
      timer = setInterval(() => {
        time--;
        this.countdown = `倒计时（${time}）`;
        if (time < 1) {
          clearInterval(timer);
          this.countdown = `重新发送`;
        }
      }, 1000);
    },
    // 发送验证码请求
    sendOut() {
      postRequest({
        url: `/api/v1/user/sendsms?type=forget&mobile=${this.changeMobile.mobile}`,
      }).then((res) => {
        if (res.data) {
          this.$message.success("验证码已发送，请注意查收");
        } else {
          this.$message.error(res.errmsg);
        }
      });
    },
    // 触发修改按钮
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loginFunc();
        } else {
          return false;
        }
      });
    },

    // 调用修改接口
    loginFunc() {
      postRequest({
        url: `/security/forget`,
        data: {
          code: this.changeMobile.mobilein,
          mobile: this.changeMobile.mobile,
          password: this.changeMobile.mobilepass,
          captcha: this.changeMobile.captcha
        },
      }).then((res) => {
        if (res.data) {
          this.$message.success("修改成功")
          this.$store.commit('setChangepassshow', false)
        } else {
          this.$message.error(res.errmsg)
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.email {
  font-size: 14px;
  color: #4e5969;
  line-height: 1.5;
  margin-bottom: 6px;
  margin-top: 20px;
}

// 组件自带样式修改-----------------------------------------------------
.el-dialog__header {
  padding-top: 0;
}

::v-deep .el-dialog--center .el-dialog__body,
::v-deep .el-dialog__header {
  padding: 0;
}

::v-deep .el-radio__input.is-checked+.el-radio__label {
  color: #86909c !important;
}

::v-deep .el-form-item {
  margin-bottom: 12px !important;
}

::v-deep .el-radio__inner {
  width: 16px !important;
  height: 16px !important;
  border-radius: 2px 2px 2px 2px !important;
  border: 1px solid #e5e6eb !important;
}

::v-deep .el-input__inner {
  background: #f7f8fa !important;
  border: none !important;
  border-radius: 4px 4px 4px 4px !important;
}

::v-deep .el-tabs__active-bar {
  background-color: #165dff !important;
  height: 3px !important;
  border-top-left-radius: 2px !important;
  border-top-right-radius: 2px !important;
}

::v-deep .el-tabs__item.is-active {
  color: #165dff !important;
}

::v-deep .el-tabs__item {
  color: #4e5969 !important;
}

::v-deep .el-input-group__append,
.el-input-group__prepend {
  color: #165dff !important;
  border: none !important;
  margin: 0 15px !important;
}

::v-deep .el-input-group__append {
  padding-right: 15px !important;
}

::v-deep .el-tabs__nav-wrap::after {
  display: none !important;
}

::v-deep .el-radio__label {
  font-size: 12px !important;
}

::v-deep .el-dialog {
  width: 376px !important;
  // margin: 0 auto !important;
  padding: 32px 48px !important;
  background: #ffffff !important;
  border-radius: 12px !important;
}

// --------------------------------------------------------------------
.register {
  display: flex;
  justify-content: space-between;
  line-height: 1.5;
  align-items: center;
  color: #1d2129;
  font-weight: bold;
  font-size: 30px;
  margin-bottom: 8px;

  > :last-child {
    cursor: pointer;
  }
}
</style>
